const en = {
  navData: {
    indexNav: 'index',
    c2cNav: 'C2C',
    helpNav: 'help',
    loginNav: 'login',
    registerNav: 'register',
  }
};

export default en;
